import { api, config } from '../../../helpers/api';

const myRewards = '/reward_order/';
export async function getRewardCategoriesRequest() {
  const response = await api.get('/reward_category/', config('json'));
  return response.data;
}

export async function getCategoryRewardsRequest({ categoryId, limit, page }) {
  const response = await api.get(
    '/reward/',
    config('json', { category_id: categoryId, limit, page })
  );
  return response.data;
}

export async function getMyRewardsRequest() {
  const response = await api.get(myRewards, config('json'));
  return response.data.reward_orders_response;
}

export async function claimRewardRequest({ rewardId }) {
  return api.post(myRewards, { reward_id: rewardId }, config('json'));
}
